const flipImage = {
    MozTransform: 'scaleX(-1)', OTransform: 'scaleX(-1)', WebkitTransform: 'scaleX(-1)', transform: 'scaleX(-1)',
};
export {
    flipImage,
};
